<template>
  <ListaAbonos />
</template>

<script>
import ListaAbonos from '@/components/Abonos/ListaAbonos.vue'
export default {
  name: 'AbonosView',
  components: { ListaAbonos }
}
</script>



// WEBPACK FOOTER //
// src/views/socios/AbonosView.vue